import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators} from '@angular/forms';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';

@Component({
    selector: 'app-add-edit-role',
    templateUrl: './addeditrole.component.html',
})
export class AddEditRoleComponent implements OnInit {
    submitted: boolean = false;
    role: RoleModel = new RoleModel();
    name = new FormControl('', [Validators.required]);
    description = new FormControl('', [Validators.required]);
    
    constructor(
        public _restAPI: RestAPIService, private toast: ToastService,
        public dialogRef: MatDialogRef<AddEditRoleComponent>,
        @Inject(MAT_DIALOG_DATA) public roleData: RoleModel) {
            this._restAPI.loading  = false;
            this.role = JSON.parse(JSON.stringify(roleData));
            localStorage["applyRoleFilterValue"] = 'true';
        }
    
    async ngOnInit() {
        //init form controls
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    async saveRole() {
        if(!this.name.invalid && (this.role.name?.length ?? 0) > 0 && !this.description.invalid){
            this._restAPI.loading  = true;
            if (this.role.id != null && this.role.id.length > 0) {
                let postData = {
                    id: this.role.id,
                    name: this.role.name,
                    description: this.role.description,
                };

                this._restAPI.put<string>(environment.apiURL + 'api/role/edit/' + this.role.id, postData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        this.dialogRef.close(true);
                        this.toast.show("Role has been updated successfully");
                    },
                    error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
                });
            }
            else {
                let postData = {
                    name: this.role.name,
                    description: this.role.description,
                };

                this._restAPI.post<string>(environment.apiURL + 'api/role/add', postData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        this.dialogRef.close(true);
                        this.toast.show("Role has been added successfully");
                    },
                    error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
                });
            }
        }
    }
}
